<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" :colon="false">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item
              :label="$t('表类型')">
              <a-input :placeholder="$t('请输入表类型')" v-decorator="['meterTypeName', {}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('设备ID')">
              <a-input :placeholder="$t('请输入设备ID')" v-decorator="['deviceId', {}]" />
            </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                :label="$t('模组号')">
                <a-input :placeholder="$t('请输入15位IMEI代表表ID')" v-decorator="['meterId', {}]" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                :label="$t('信号强度')">
                <a-input-number v-decorator="[ 'signalLevel', {}]" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label="$t('信噪比')">
                <a-input-number v-decorator="[ 'signalPre', {}]" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label="$t('覆盖等级')">
                <a-input-number v-decorator="[ 'signalCover', {}]" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                :label="$t('小区ID')">
                <a-input-number v-decorator="[ 'signalCell', {}]" />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item
                :label="$t('上报明细')">
                <a-textarea :rows="6" :placeholder="$t('请输入上报明细')" v-decorator="['meterDetail', {}]" />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item
                :label="$t('备注')">
                <a-textarea :placeholder="$t('请输入备注')" v-decorator="['remark', {}]" />
              </a-form-item>
            </a-col>
          </a-row>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import moment from "moment"

  export default {
    name: "PartMeterModal",
    data () {
      return {
        title:this.$t("操作"),
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
        },
        url: {
          add: "/model/partMeter/add",
          edit: "/model/partMeter/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'meterType','deviceId','meterId','signalLevel','signalPre','signalCover','signalCell','meterDetail','remark'))
          let data = {'00': this.$t('小口径表'), '01': this.$t('大口径表'), '80': this.$t('平台计费水表'), '81': this.$t('阶梯计费水表'), '82': this.$t('表端计费水量表')}
          this.form.setFieldsValue({meterTypeName: data[this.model.meterType]})
      //时间格式化
        });

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //时间格式化
            
            console.log(formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })



          }
        })
      },
      handleCancel () {
        this.close()
      },


    }
  }
</script>

<style lang="less" scoped>

</style>